import React from 'react';

const SvgLikeOutline = props => (
  <svg width="1em" height="1em" viewBox="0 0 17 16" {...props}>
    <path
      d="M16.105 5.316c0 5.19-6.612 9.169-7.463 9.659a.177.177 0 0 1-.09.025.177.177 0 0 1-.09-.025C7.613 14.485 1 10.506 1 5.316 1 2.932 2.753 1 4.916 1c1.343 0 2.523.748 3.227 1.883a.482.482 0 0 0 .41.236.48.48 0 0 0 .409-.236C9.665 1.748 10.845 1 12.189 1c2.162 0 3.916 1.932 3.916 4.316z"
      stroke="#999"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgLikeOutline;
